import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import JSEncrypt from 'jsencrypt';
import rsaPublicKey from '@/assets/js/rsaPublicKey';
/**
 * @function 数组去重
 * @param {Array} arr 原数组
 * @return {Array}
 */

export function uniqueArr(arr) {
  if (arr instanceof Array) {
    return Array.from(new Set(arr));
  } else {
    return arr;
  }
}
/**
 * @function URL解析获取参数集合
 * @param {String} url
 * @return {Object} 参数集合
 */

export function parseUrl(url) {
  var reg = /([^?&=#]+)=([^?&=#]+)/g;
  var data = {};
  url.replace(reg, function () {
    data[arguments[1]] = arguments[2];
  });
  return data || {};
}
/**
 * @function 字符串支持识别超链接
 * @param {String} str
 */

export function httpHtml(str) {
  str = str.trim();
  var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
  return str.replace(reg, '<a href="$1$2" target="_blank">$1$2</a>');
}
/**
 * @function 锚点定位
 * @param {String} selector Node节点
 */

export var scrollIntoView = function scrollIntoView(selector) {
  var selectNode = document.querySelector(selector);

  if (!selectNode) {
    return new Error('未发现相关节点');
  }

  selectNode.scrollIntoView({
    behavior: 'smooth',
    // 定义动画过渡效果， "auto"或 "smooth" 之一。默认为 "auto"
    block: 'start',
    // 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"
    inline: 'nearest' // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"

  });
};
/**
 * @func 平滑滚动到顶部 - 根据设备重绘时间自动循环滚动
 * @param {String} dom 可以被querySelector查询到的节点标识字符串，Id或class
 * @param {Number} slice 滚动速率，一次滚动划过的距离，n表示一次平滑滚动划过剩余路径的1/n
 */

export function scrollToTop(dom) {
  var slice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  // 如果没有传DOM节点，则默认在全局滚动
  if (!dom) {
    var sTop = document.documentElement.scrollTop || document.body.scrollTop;

    if (sTop > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, sTop - sTop / slice);
    }
  } else {
    // 指定DOM节点滚动
    if (!window.scrollTempDom) {
      window.scrollTempDom = dom;
      window.scrollSlice = slice;
    }

    if (typeof window.scrollTempDom === 'number') {
      window.scrollTempDom = null;
      return;
    }

    var _sTop = document.querySelector(window.scrollTempDom).scrollTop;

    if (_sTop > 0) {
      window.requestAnimationFrame(scrollToTop);
      document.querySelector(window.scrollTempDom).scrollTo(0, _sTop - _sTop / window.scrollSlice);
    } else {
      window.scrollTempDom = null;
    }
  }
}
/**
 * @func 密码RSA加密
 * @param {String} pwd 密码明文
 * @return {String}
 */

export function rsa(pwd) {
  var jsEncrypt = new JSEncrypt();
  jsEncrypt.setPublicKey(rsaPublicKey);
  return jsEncrypt.encrypt(pwd);
}
/**
 * @func 倒计时工具
 * @param {Number} count 倒计时多久，默认60秒
 * @param {Function} callback 倒计时完成，触发回调函数
 */

export function countDownTimer() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  count = parseInt(count);

  if (count <= 0) {
    callback && callback();
    return;
  }

  var remain = count; // 设置定时器，开始倒数

  var timer = window.setInterval(function () {
    if (remain === 0) {
      callback && callback();
      clearInterval(timer);
    } else {
      remain--;
    }
  }, 1000);
}